import { render, staticRenderFns } from "./OrderDetailStatusBadge.vue?vue&type=template&id=85148dfc&scoped=true"
import script from "./OrderDetailStatusBadge.vue?vue&type=script&lang=js"
export * from "./OrderDetailStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailStatusBadge.vue?vue&type=style&index=0&id=85148dfc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85148dfc",
  null
  
)

export default component.exports